import { Component, Input, OnInit } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MobiOfficeUiModule } from "@mobi-office-ui";

import { ICONS } from "../../models/svg-icons";
import { COLUMN_LIST_TYPE, Int_TableColumn, TABLE_COLUMN_TYPE } from "../../models";

@Component({
  selector: "mobi-office-table-columns-view",
  imports: [MobiOfficeUiModule, CommonModule],
  templateUrl: "./table-columns-view.component.html",
  styleUrl: "./table-columns-view.component.scss",
})
export class TableColumnsViewComponent {
  @Input({ required: true }) item!: any;
  @Input({ required: true }) column!: Int_TableColumn;

  readonly TABLE_COLUMN_TYPE = TABLE_COLUMN_TYPE;
  readonly COLUMN_LIST_TYPE = COLUMN_LIST_TYPE;
  readonly ICONS = ICONS;
}
